import { Component, ViewChild } from '@angular/core';
import { NavParams, NavController, ModalController, PopoverController, Events, Platform } from 'ionic-angular';
import { EventsProvider } from '../../providers/events/events';
import moment from 'moment';
import { LocationsProvider } from '../../providers/locations/locations';
import { CoLocationComponent } from '../co-location/co-location';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { ConfigProvider } from '../../providers/config/config';
import { CoEventsRegisterModalPage } from '../../pages/co-events-register-modal/co-events-register-modal';
import { CoEventCardRegistrationStatusComponent } from '../co-event-card-registration-status/co-event-card-registration-status';
import { AppState } from '../../config/state';
import { SocialMediaSharingProvider } from '../../providers/social-media-sharing/social-media-sharing';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoEventDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-event-details',
  templateUrl: 'co-event-details.html',
  inputs: []
})
export class CoEventDetailsComponent {
  shouldPageLoad: boolean = false;
  eventDetail: any;
  text: string;
  locationDetails: any;
  showLocation: boolean = false;
  clientKeyword: string;
  searchTags: any;
  showRegistrants: boolean = false;
  eventId: number = -1;
  registrantList: Array<any>;
  agesArray: any;
  mode: any;
  header: any;
  footer: any;
  isSharedScreen: boolean;
  eventTypes: any;
  wideScreen: boolean;
  menuSide: string;
  @ViewChild(CoEventCardRegistrationStatusComponent) regComponent: CoEventCardRegistrationStatusComponent;
  constructor(public eventsProvider: EventsProvider, public state: AppState, public navCtrl: NavController,public navParams: NavParams, public locationsProvider: LocationsProvider, private clientDetails: ClientDetailsProvider, public config: ConfigProvider, public modalCtrl: ModalController, public popoverCtrl: PopoverController, private events: Events, private socialShare: SocialMediaSharingProvider, private platform : Platform, private sounds : SoundsProvider) {
    this.wideScreen = this.platform.width() > 600;
    this.eventId = this.navParams.data.eventId;
    this.agesArray = this.navParams.data.ages;
    this.mode = this.state.mode;
    this.isSharedScreen = this.state.sharedScreen;
    this.header = this.state.header;
    this.footer = this.state.footer;
    this.eventTypes = this.state.eventColors.types;
    this.menuSide = this.state.burgerMenu.menuSide;
    // this.searchTags = navParams.data.searchTags
    let sr = this.navParams.get('showRegistrants');
    this.showRegistrants = (typeof(sr) !== undefined) ? sr : false;
    this.querySingleEvent();

    if(this.showRegistrants){
      this.loadRegistrants();
    }

    this.events.subscribe('registeredEvent', ()=> {
      this.querySingleEvent();
    })

    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
    });
  };
  ngOnDestroy(){
    this.events.unsubscribe('updateAllEvents');
    this.events.unsubscribe('registeredEvent');
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  querySingleEvent(){
    this.eventsProvider.getSingleEvent(this.eventId).then((res) => {
      this.eventDetail = res.eventDetails;
      this.events.subscribe('updateAllEvents', async () => {
        this.eventDetail = await this.eventsProvider.checkInterestedEvents(res.eventDetails);
      });
      this.searchTags = res.types;
      this.shouldPageLoad = true;
      this.events.publish('updateEventData', this.eventDetail);
    });
  };

  loadRegistrants(){
    this.eventsProvider.getEventRegistrants(this.eventId).then((registrants) => {
      // console.log('registrants', registrants);
      this.registrantList = registrants;
    });
  }

  registerClick(event, details){
    // console.log("registered, ", event, details);
  };

  isClosingSoon(event: any) {
    if(moment(event).subtract(2, 'day').isAfter(moment())){
      return true;
    };
    return false;
  };

  toggleBranchInfo(branch){
    if (this.showLocation){
      this.showLocation = false;
    } else {
      this.showLocation = true;
    }
  };

  eventCheck() {
    if(!this.eventDetail.allowReg) {
      return 'noRegistration';
    }

    if(this.eventDetail.modifiedType == 'canceled') {
      return 'eventCanceled';
    }

    if(this.eventDetail.registrationOpens && moment(this.eventDetail.registrationOpens).isBefore('2000')) this.eventDetail.registrationOpens = false;

    if(moment().isBefore(this.eventDetail.registrationCloses)) {
      if(!this.eventDetail.registrationOpens || moment().isAfter(this.eventDetail.registrationOpens)) {
        return this.eventFullCheck() ? 'registationFull' : 'registrationOpen';
      }
      else if(moment().isBefore(this.eventDetail.registrationOpens)) {
        return 'notOpenYet';
      }
      else {
        return 'registrationClosed';
      }
    }
    else {
      return 'registrationClosed';
    }
  }

  eventFullCheck() {
    let max =  this.eventDetail.maxAttendees;
    let registered = this.eventDetail.totalRegistrants;
    if (max <= 10) {
      if (max - registered > 2) {
        return true;
      } else {
        return false;
      };
    } else if (max > 10) {
      if (registered / max < 0.9) {
        return true;
      } else {
        return false;
      };
    };
  };

  getEventImage(eventType) {
    try {
      let eventTypeObject = this.eventTypes.find(object => object.name === eventType);
      return eventTypeObject.image;
    } catch (ex) {
      return "";
    }
  };

  goToLocation(locationId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoLocationComponent, { location: locationId, showNavbar: true });
    });
  }

  openRegisterModal(event) {
    let modal = this.modalCtrl.create(CoEventsRegisterModalPage, { event: event });
    modal.present();
  }

  openInterestedPopover(event){
    let self = this;
    this.eventsProvider.openInterestedPopover(event, this.eventDetail, self);
  }

  shareEvent(button) {
    if (this.mode === 'app') {
      this.socialShare.shareOptions(this.eventDetail);
    } else if (this.mode === 'desktop') {
      this.eventsProvider.openSocialMediaPopover(button, this.eventDetail);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-event-details/co-event-details.ts